import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CustomMessageService, LocalStorageService, UtilService} from "library";
import {UserData} from "projects/store/src/app/interfaces";
import {LocalStorageKey} from "projects/store/src/app/enums";
import {CommissionsService} from "projects/store/src/app/services/api/v1/commissions.service";
import { ResponseHttpError, ResponseHttpSuccess } from "library";
import {HttpStatusCode} from "@angular/common/http";

@Component({
  selector: 'app-commission-reports-cancellations',
  templateUrl: './commission-reports-cancellations.component.html',
  styleUrls: ['./commission-reports-cancellations.component.scss']
})
export class CommissionReportsCancellationsComponent implements OnInit{
  listCancelationsOfUser: any;

  userData: UserData;
  @Input() year!: number;
  @Input() month!: number;
  @Output() onListCancellations = new EventEmitter<any>

  constructor(private commissionsService: CommissionsService,
              private customMessageService: CustomMessageService,
              protected utilService: UtilService,
              private localStorageService: LocalStorageService) {
    this.userData = this.localStorageService.get(LocalStorageKey.data);
  }

  ngOnInit() {
    this.load();
  }

  load(){
    this.utilService.enablePageLoading();
    this.commissionsService.getCancellationsOfUser(this.userData.user.id, this.month, this.year).subscribe({
      next: (resp: ResponseHttpSuccess) =>{
        if (resp.status === HttpStatusCode.Ok){
          this.listCancelationsOfUser = resp.body.data.list;
          this.onListCancellations.emit(this.listCancelationsOfUser);
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.utilService.disablePageLoading();
      },
      error: (error: ResponseHttpError) => {
        this.customMessageService.responseNoticeHandler(error);
        this.utilService.disablePageLoading();
      }
    })
  }
}
